import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormInputComponent } from './components/form-input/form-input.component';
import { FormLabelComponent } from './components/form-label/form-label.component';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { FormPasswordInputComponent } from './components/form-password-input/form-password-input.component';
import { ButtonLegacyModule } from '../button-legacy/button-legacy.module';
import { IconModule } from '../icon/icon.module';
import { FormTextareaComponent } from './components/form-textarea/form-textarea.component';
import { FormChipListComponent } from './components/form-chip-list/form-chip-list.component';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { FormSubtextComponent } from './components/form-subtext/form-subtext.component';

const components = [
  FormErrorComponent,
  FormInputComponent,
  FormPasswordInputComponent,
  FormLabelComponent,
  FormTextareaComponent,
  FormChipListComponent,
  FormSubtextComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonLegacyModule,
    MatInputModule,
    MatChipsModule,
    MatIconModule,
    IconModule,
    MatAutocompleteModule,
  ],
  exports: components,
})
export class FormModule {}
